import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const Container = styled.div`
    width: 555px;
    font-size: ${theme.font.size10};
    margin: 20px 0px 0px 20px;
`;

export const ContentContainer = styled.div`
    width: 500px;
    font-size: ${theme.font.size10};
    margin: 20px 0px 0px 30px;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px;
    width: 100%;
    border-bottom: 1px solid #000;

    h3 {
        font-size: ${theme.font.size11};
        font-weight: bold;
        margin: auto;
    }
`;

export const Row = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    font-family: 'Times New Roman', Times, serif;

    &.spaced {
        justify-content: space-between;
    }
`;

export const ValuesContainer = styled.div`
    margin: 0 24px;
`;

export const LogoGroup = styled.div`
    display: flex;
`;

export const Logo = styled.img`
    width: 120px;
    margin: 0 10px;
`;

export const Value = styled.span`
    font-size: ${theme.font.size11};
    font-weight: bold;
    font-family: 'Arial', sans-serif;
    letter-spacing: .6px;
    
    margin: 0 10px;
`;
